import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Container, TimeFilters } from './ShimmerExchangeRateGraph.styles';
import { ShimmerExchangeRateGraphProps } from './ShimmerExchangeRateGraph.types';
import { skeletonProps } from '../Shimmer.types';

export const ShimmerExchangeRateGraph = ({ width, height }: ShimmerExchangeRateGraphProps) => {
  return (
    <Container $width={width} $height={height}>
      <Skeleton width={100} height={14} {...skeletonProps} />
      <Skeleton width={280} height={38} {...skeletonProps} />
      <Skeleton width="100%" height={180} borderRadius={4} {...skeletonProps} />
      <TimeFilters>
        <Skeleton width={24} height={20} {...skeletonProps} />
        <Skeleton width={24} height={20} {...skeletonProps} />
        <Skeleton width={24} height={20} {...skeletonProps} />
      </TimeFilters>
    </Container>
  );
};
